import axios from 'axios';
import {
  clearActiveTenant,
  getActiveTenant,
  isTenantDenied403,
  isTenantRequiredRequest,
  tenantSelectionRequiredError,
} from './helpers/tenantHelpers';

const aiApi = axios.create({
  baseURL: 'https://ai.abon.ai',
  withCredentials: false, // Not needed unless the AI service sets cookies
});

aiApi.interceptors.request.use((config) => {
  const tenant = getActiveTenant();
  const token = localStorage.getItem("token") || localStorage.getItem("access_token");
  const needsTenant = isTenantRequiredRequest(config.url);

  config.headers = config.headers || {};
  const aiApiKey = process.env.REACT_APP_AI_ASSISTANT_API_KEY || '';
  if (aiApiKey) config.headers['X-API-Key'] = aiApiKey;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (needsTenant && !tenant?.id) {
    return Promise.reject(tenantSelectionRequiredError());
  }
  if (tenant?.id)       config.headers["X-Tenant-ID"] = tenant.id;
  if (tenant?.domain)   config.headers["X-Tenant-Domain"] = tenant.domain;
  if (tenant?.industry) config.headers["X-Tenant-Industry"] = tenant.industry;

  return config;
});

aiApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only a genuine tenant-denial 403 clears the tenant — an AI-service 403 on
    // token expiry or a single denied action must not strip the whole session
    // (which then trips the client-side tenant guard and bounces the app).
    if (isTenantDenied403(error?.response?.status, error?.response?.data)) {
      clearActiveTenant();
    }
    return Promise.reject(error);
  }
);

export default aiApi;
